import "antd/lib/tabs/style/css";

import React from "react";

import ZenginsinImage from "@assets/images/zenginsin.png";
import {
	BackgroundCard,
	CasinoSlider,
	MostPlayedSlider,
	ProvidersSlider,
	ScrollToTop,
	WinnersSlider,
} from "@pages/casino/components";
import { GameFilters, PromotionBanner } from "@pages/casino/containers";
import { getTournamentOptions } from "@pages/casino/utils";

import { TabContentWrapper } from "./elements.js";
import useController from "./useController.js";

const TabContent = ({ containers, activeTab, user }) => {
	const {
		state: { sortedContainer, footerImgWebp, footerImgSvg, footerLogoImgSvg },
	} = useController({ containers, user });

	return (
		<TabContentWrapper hasCasinoPromotionBanner={window.HAS_CASINO_PROMOTION_BANNER}>
			{window.HAS_CASINO_PROMOTION_BANNER && <PromotionBanner />}

			{window.IS_WON_SLIDER_IN_FIRST_PLACE_AND_IN_HOME_PAGE && <WinnersSlider />}

			<GameFilters
				showProvidersFilter
				showCategoriesFilter
				showIFeelLucky
				showFavorites
				showTournaments
				showSearch
				showTvBet={window.TV_BET_VISIBLE}
				showAllGames
				activeTab={activeTab}
				tournamentOptions={getTournamentOptions()}
			/>

			{!window.IS_WON_SLIDER_IN_THIRD_PLACE &&
				!window.IS_WON_SLIDER_IN_FIRST_PLACE_AND_IN_HOME_PAGE && <WinnersSlider />}

			{sortedContainer.slice(0, 2).map((container, index) =>
				container?.type === "mostPlayed" ? (
					<MostPlayedSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				) : (
					<CasinoSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				)
			)}

			{window.IS_WON_SLIDER_IN_THIRD_PLACE &&
				!window.IS_WON_SLIDER_IN_FIRST_PLACE_AND_IN_HOME_PAGE && (
					<WinnersSlider colorful={window.IS_HOME_WON_SLIDER_IN_FIRST_PLACE} />
				)}

			{sortedContainer.slice(2, 3).map((container, index) =>
				container?.type === "mostPlayed" ? (
					<MostPlayedSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				) : (
					<CasinoSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				)
			)}

			<ProvidersSlider activeTab={activeTab} />

			{sortedContainer.slice(3, 5).map((container, index) =>
				container?.type === "mostPlayed" ? (
					<MostPlayedSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				) : (
					<CasinoSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				)
			)}

			{sortedContainer.slice(5, containers.length).map((container, index) =>
				container?.type === "mostPlayed" ? (
					<MostPlayedSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				) : (
					<CasinoSlider
						key={container.id}
						data={container}
						size={index == 2 ? "medium" : "small"}
					/>
				)
			)}

			<BackgroundCard
				isTransparent={window.FOOTER_BG_TRANSPARENT}
				image={
					window.FOOTER_HAS_INLINE_IMAGE && (footerImgWebp ? footerImgWebp : footerImgSvg)
				}>
				{window.FOOTER_HAS_IMAGE && (
					<img
						src={window.TENANT === "Zenginsin" ? ZenginsinImage : "/logo_white.webp"}
						height={window.TENANT === "Zenginsin" ? 60 : 120}
					/>
				)}

				{window.FOOTER_HAS_INLINE_IMAGE && <img src={footerLogoImgSvg} />}
			</BackgroundCard>
			<ScrollToTop />
		</TabContentWrapper>
	);
};

export default TabContent;
